export const isInternalNetworkTunnelUiVisible = ({
  brokerFetched,
  brokerEnabled,
  tailscaleFetched,
  tailscaleEnabled,
}: {
  brokerFetched: boolean;
  brokerEnabled: boolean;
  tailscaleFetched: boolean;
  tailscaleEnabled: boolean;
}): boolean =>
  brokerFetched && tailscaleFetched && brokerEnabled && tailscaleEnabled;
